<template>
  <div v-if="loaded"
    :class="['buybuttonVue', $parent.pickedProduct.discount > 0.01 && $parent.pickedProduct.tax > 1 ? 'discount' : '']">
    <!-- Show buybutton if item is on stock and no backorder or show buybutton if item is out of stock but backorder is available. Also show if item has not been set to "may not sell"-->

    <div v-if="!$root.display.showPriceNoBuyButton">
      <div v-if="onlyBuyWhenLoggedInCheck">
        <div class="buyBtnContainer"
          v-if="(((this.$parent.pickedProduct.availability != 0 && !backorder) || (this.$parent.pickedProduct.availability == 0 && (backorder || preorder))) && this.$parent.pickedProduct.availability != 2) || this.$parent.pickedProduct.availability == 5">
          <transition-group :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
            <button :key="1" class="add" :class="{ 'subadd': this.$parent.typeOfPurchase == 'sub' }"
              v-if="((showAddToBasket && (((this.$parent.pickedProduct.availability != 0 || this.$parent.pickedProduct.availability != 2) && (!backorder && !preorder)) || (this.$parent.pickedProduct.availability == 5)))) && loaded && !this.$root.turbocheckout"
              @click.prevent="addToBasket(id)">{{ this.$parent.typeOfPurchase == 'sub' ? this.$root.language.wsm_Subscribe : this.$root.language.wsm_AddToBasket }}</button>
            <button :key="1" class="add" :class="{ 'subadd': this.$parent.typeOfPurchase == 'sub' }"
              v-if="((showAddToBasket && (((this.$parent.pickedProduct.availability != 0 || this.$parent.pickedProduct.availability != 2) && (!backorder && !preorder)) || (this.$parent.pickedProduct.availability == 5)))) && loaded && this.$root.turbocheckout"
              @click.prevent="addToBasketButReallyFast(id)">{{ this.$root.language.wsm_Checkout }}</button>
            <div :key="2"
              v-if="(this.$parent.pickedProduct.availability == 0 && (backorder || preorder)) && currentQuant == 0 && showAddToBasket">
              <button v-if="backorder" class="add" @click.prevent="showModal = true">{{
                this.$root.language.wsm_AddToBasket }}</button>
              <button v-if="!backorder && preorder" class="add notify" @click.prevent="showModal = true"><i
                  class="fas fa-bell"></i> <span v-html="this.$root.language.wsm_Preorder"></span></button>
            </div>
          </transition-group>
          <transition :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
            <div class="quantityButtons" :class="{ 'subquants': this.$parent.typeOfPurchase == 'sub' }"
              v-if="(currentQuant != 0 && showQuant) && loaded && !this.$root.turbocheckout">
              <button class="minus" @click.prevent="adjustQuantity('minus')"><i class="fas fa-minus"></i></button>
              <input disabled v-model="currentQuant" />
              <button class="plus" @click.prevent="adjustQuantity('plus')"><i class="fas fa-plus"></i></button>
            </div>
          </transition>
          <Transition name="slide">
            <p class="updatedBasket" v-if="(currentQuant != 0 && showQuant) && loaded && purchaseTypeChanging">{{ this.$parent.typeOfPurchase == 'sub' ? `${$root.language.wsm_sub_product_changed_to.replace('%%PURCHASETYPE%%', $root.language.wsm_sub_subscriptionPurchase)}` : `${$root.language.wsm_sub_product_changed_to.replace('%%PURCHASETYPE%%', $root.language.wsm_sub_oneTimePurchase)}`}}</p>
          </Transition>
          
        </div>
      </div>
    </div>
    <!-- Out of stock, no backorder -->
    <div v-if="this.$parent.pickedProduct.availability == 0 && (!backorder && !preorder)">
      <button class="add outOfStock">{{ this.$root.language.wsm_OutOfStock }}</button>
    </div>
    <!-- include backorder modal -->
    <div v-if="this.$parent.pickedProduct.availability == 0 && (backorder || preorder)">
      <backorderModal @addToBasket="addToBasket" v-if="showModal" @close="showModal = false" :preorder="preorder"
        :productid="id" :backorder="backorder" :productname="productname"></backorderModal>
    </div>
    <!-- May not be sold, no backorder -->
    <div v-if="this.$parent.pickedProduct.availability == 2">
      <MessengerButton
        v-if="this.$parent.pickedProduct.locale == 'th-TH' || this.$parent.pickedProduct.currencyType == 'THB'">
      </MessengerButton>
      <button v-else class="add outOfStock">{{ this.$root.language.wsm_NotForSale }}</button>
    </div>
  </div>
</template>
  
<script>
import backorderModal from './backorder';
import MessengerButton from '../../../integrationtest/src/components/messengerButton.vue'
import {getBasket, updateQuantity} from '../productapi'
export default {
  name: 'buyCutton',
  props: ["id"],
  components: {
    backorderModal,
    MessengerButton
  },
  data() {
    return {
      currentQuant: 1,
      showAddToBasket: true,
      showModal: false,
      showQuant: "",
      purchaseTypeChanging: false,
      entry: true,
      quantity: parseInt(this.$parent.pickedProduct.quantity),
      backorder: this.$parent.pickedProduct.isBackorderAllowed,
      loaded: false,
      productname: this.$parent.pickedProduct.productname,
      preorder: this.$parent.pickedProduct.isPreorderAllowed,
    };
  },
  async created() {
    this.currentQuant = await this.getQuantity(this.$parent.pickedProduct.productId)
    if (this.currentQuant == 0) {
      this.showQuant = false;
      this.showAddToBasket = true;
    } else {
      if(!this.$root.turbocheckout) {
      this.showAddToBasket = false;
      this.showQuant = true;
      }

    }
    this.loaded = true;
  },
  mounted() {

  },
  watch: {
    '$parent.pickedProduct': {
      async handler() {
        this.purchaseTypeChanging = false;
        this.loaded = false;
        this.currentQuant = await this.getQuantity(this.$parent.pickedProduct.productId)
        if (this.currentQuant == 0) {
          this.showQuant = false;
          this.showAddToBasket = true;
        } else {
          if(!this.$root.turbocheckout) {
            this.showAddToBasket = false;
            this.showQuant = true;
          }
        }

        getBasket().then(res => {
          const basket = res.data?.payload?.basket?.lines

          if (basket?.length && basket.find(x => x.productID == this.$parent.pickedProduct.productId)) {
            this.$emit('changeTypeOfPurchase', basket.find(x => x.productID == this.$parent.pickedProduct.productId).isSubscription ? 'sub' : 'single');
          } else {
            this.$emit('changeTypeOfPurchase', 'single');
          }
        })

        this.loaded = true;
      },
    },
    currentQuant: {
      handler() {
        if (this.currentQuant == 0) {
          this.showQuant = false;
          setTimeout(() => {
            this.showAddToBasket = true;
          }, 100)
        } else {
          if(!this.$root.turbocheckout) {
          this.showAddToBasket = false;
          setTimeout(() => {
            this.showQuant = true;
          }, 100)
        }
        }
      }
    }
  },
  methods: {
    showTypeChange(change) {
      this.purchaseTypeChanging = false;
      if(this.currentQuant > 0 && change) {
        this.purchaseTypeChanging = true;

        document.querySelectorAll("#basketOpener .pCount")[0].classList.remove("bounce")
        setTimeout(() => {
          document.querySelectorAll("#basketOpener .pCount")[0].classList.add("bounce")
        }, 500)
        setTimeout(() => {
          this.purchaseTypeChanging = false;
        }, 2000)
      }

    },
    getQuantity(productId) {
      return getBasket().then(res => {
        const basket = res.data?.payload?.basket?.lines

        if (basket?.length && basket.find(x => x.productID == productId)) {

          return parseInt(basket.find(x => x.productID == productId).quantity)
        } else {
          return 0
        }
      })
    },
    setQuantity: function (amount) {
      this.currentQuant = amount;
    },
    addToBasket: async function () {
      this.entry = false;

      await updateQuantity(this.$parent.pickedProduct.productId, 1, (this.$parent.typeOfPurchase == 'sub'), this.$parent.pickedInterval, (this.$root.pointshop == "Y")).then(response => {
        if (response.data.errorMessage.length > 0) {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
        } else {
          window.ajaxBasket.refresh();
          this.currentQuant = 1;
          this.$emit('gtag')
        }
      })
    },
    async addToBasketButReallyFast() {
        await this.addToBasket();
        window.location = window.basedir + '/checkOutServlet?sirius=/checkout-continue&logintype=guest';
    },
    adjustQuantity: function (type) {
      this.entry = false;
      var newQuant = type == "minus" ? (this.currentQuant - 1) : (this.currentQuant + 1);
      
      updateQuantity(this.id, newQuant, (this.$parent.typeOfPurchase == 'sub'), this.$parent.pickedInterval, (this.$root.pointshop ? "Y" : false)).then(response => {
        if (response.data.errorMessage.length > 0) {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
        } else {
          window.ajaxBasket.refresh();
          this.currentQuant = type == 'minus' ? (this.currentQuant - 1) : (this.currentQuant + 1);
        }
      })
    },
  },
  computed: {
    onlyBuyWhenLoggedInCheck: function () {
      if (this.$root.display.OnlyBuyWhenLoggedIn) {
        if (this.$root.display.loggedIn) {
          return true;
        } else {
          return false;
        }
      } else {
        return true
      }
    }
  }
};
</script>
  
<style lang="scss" scoped>
.buybuttonVue {
  width: 100%;
  display: flex;
  vertical-align: top;

  .buybuttoncontainer {
    width: 100%;

    .availability {
      display: flex;

      .quantityButtons {
        width: auto;
        min-width: 91px;
      }
    }
  }
}

.discount {
  width: 100%;
}

.gallery2020 {}

.add {
  width: 100%;
}

.add {
  background-position: center !important;
  transition: background 0.2s !important;
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 15px;
  -webkit-appearance: none;
  border: 1px solid darkseagreen;
  background: #7caf63;
  color: white;
  cursor: pointer;
  vertical-align: top;

  &:hover {
    background: darken(#7caf63, 5%);
  }

  i {
    color: white;
    font-size: 0.8em;
    vertical-align: top;
    margin-top: 2px;
  }
}

.add.subadd {
  border: 1px solid #e7c482;
  background: #d8a64b !important;

  &:hover {
    background: darken(#d8a64b, 5%);
  }
}

.notify {
  background: #004570;
  border: 1px solid #004570;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
      color:white;
      margin-left: 0.3rem;
    }
  &:hover {
    background: #206d9c;
    border: 1px solid #1c73a9;
  }
}

.nosale {
  .outOfStock {
    font-size: 0.7em;
    min-height: 22px;
  }
}

.outOfStock {
  background: transparent;
  color: #7caf63;
  border: 1px solid #7caf63;
  font-weight: bold;
  cursor: default;
}

.grid {
  .add {
    width: 100%;
    padding: 0;
    margin: 0;
    display: block;
    float: none;
    border-radius: 0;
    padding: 6px;
  }

  .quantityButtons {
    height: 29px;
    text-align: left;
    width: 28%;

    input {
      width: 12%;
      height: 23px;
      min-width: 32px;
    }
  }
}

.quantityButtons {
  text-align: right;
  height: 29px;
	min-width: 89px;
  button {
    height: 100%;
    background-position: center !important;
    transition: background 0.6s !important;
    border-radius: 3px;
    border-radius: 3px;
    border-radius: 3px;
    padding: 3px 8px;
    -webkit-appearance: none;
    border: 1px solid darkseagreen;
    background: #7caf63;
    color: white;
    display: inline-block;
    margin: 0;
    cursor: pointer;

    .fas {
      color: white;
      font-size: 0.8em;
    }

  }

  .plus {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .minus {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.quantityButtons.subquants {
  button {
    border: 1px solid #b68c3d;
    background: #d8a64b !important;
  }

  input {
    border-top: 1px solid #b68c3d;
    border-bottom: 1px solid #b68c3d;
  }
}
.updatedBasket {
  font-size: 0.9rem;
	color: #547d9b;
  margin:0;
	margin-left: 1rem;
}

.buyBtnContainer {
  display:flex;
  align-items: center;
}

input {
  width: 40%;
  display: inline-block;
  text-align: center;
  color: #004570 !important;
  background: #ffffff;
  border-top: 1px solid #7caf63;
  border-bottom: 1px solid #7caf63;
  border-right: none;
  border-left: none;
  max-width: 30px;
  font-size: 1.1em;
  font-weight: bold;
  vertical-align: top;
  height: 23px;
  padding-top: 3px;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

.slide-enter-active {
  animation: slide-in 0.5s;
}
.slide-leave-active {
  animation: slide-out 0.5s;
}
@keyframes slide-in {
  0% {
    transform: translateY(10px);
    opacity:0;
  }
  100% {
    transform: translateY(0px);
    opacity:1;
  }
}
@keyframes slide-out {
  0% {
    transform: translateY(0);
    opacity:1;
  }
  100% {
    transform: translateY(-20px);
    opacity:0;
  }
}

@media screen and (max-width: 700px) {
  .grid {
    .addToBasketButton {
      .add {
        width: 100%;
        min-height: 29px;
      }

      .quantityButtons {
        text-align: right;
        height: 30px;
        margin-left: -3px;

        input {
          height: 24px;
        }
      }
    }
  }

  .list {
    .productActionBar {
      .adminBtn {
        .add {
          width: 100%;
          padding: 7px;
        }
      }

      .addToBasketButton {
        .add {
          width: 100%;
          padding: 7px;
        }
      }

      .quantityButtons {
        height: 30px;
        margin-left: -3px;

        input {
          height: 24px;
        }
      }
    }
  }
}

@media screen and (max-width: 440px) {
  .grid {
    .addToBasketButton {
      .quantityButtons {
        text-align: left;
      }
    }
  }
}
</style>
  

<style lang="scss">
.discountYouSave {
  .additionalInfo {
    p {
      margin: 0;
    }
  }
}</style>